/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { documentsIndex } from "../../funcs/documentsIndex.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.IndexTextRequest$inboundSchema,
};

export const tool$documentsIndex: ToolDefinition<typeof args> = {
  name: "documents-index",
  description: `Index a document from text content

Index a document into the specified index by providing the content as a JSON object.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await documentsIndex(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
